import PropTypes from "prop-types"
import { map, get, isFunction } from "lodash"
import classNames from "classnames"
import { List, ListItemButton, Grid, ListSubheader } from "@mui/material"
import { COLUMNS } from "../shapes"
import GridCell from "../grid-cell"

function makeClick(index, click) {
  if (index === 0) { return undefined }
  return () => click()
}

function getValue(column, category) {
  const { id, formatter, render } = column
  // Render overrides formatter
  if (isFunction(render)) {
    return render(category)
  }

  if (isFunction(formatter)) {
    return formatter(get(category, id))
  }

  return get(category, id)
}
export default function FactorCategories({ categories, selectedFactorCategory, setFactorCategory, columns }) {
  return (
    <List>
      <ListSubheader disableSticky className="factor-categories-subheader">
        <Grid container sx={{ width: "100%" }}>
          <GridCell className="label" size="grow" />
          {map(columns, ({ id, name }) => <GridCell key={id} size="grow">{name}</GridCell>)}
        </Grid>
      </ListSubheader>
      {map(categories, (category, index) => <ListItemButton
        key={category.id}
        onClick={makeClick(index, () => setFactorCategory(category.id))}
        disabled={index === 0}
        selected={category.id === selectedFactorCategory}
        className={classNames("category", category.id)}
      >
        <Grid container sx={{ width: "100%" }}>
          <GridCell className="label" size="grow">
            {category.id}
          </GridCell>
          {map(columns, (column) => <GridCell key={get(column, "id")} size="grow">{getValue(column, category)}</GridCell>)}
        </Grid>
      </ListItemButton>,
      )}
    </List>
  )
}

FactorCategories.propTypes = {
  categories: PropTypes.array.isRequired,
  selectedFactorCategory: PropTypes.string.isRequired,
  setFactorCategory: PropTypes.func.isRequired,
  columns: COLUMNS.isRequired,
}
